import request from "@/utils/request";
import { formateObjToParamStr, formateFenxiParamStr } from "@/utils";
// import { encryptByDES } from '@/utils/crypto'
import qs from "qs";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;
const REAL_BASE_API =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_REAL_BASE_API
    : process.env.VUE_APP_BASE_API;
const LOGIN_API = process.env.VUE_APP_LOGIN_API;
const FENXI_HOST = "https://fenxiplus.mktindex.com";
export function getParams(param) {
  return request({
    url: `${BASE_API}/api/get_params`,
    method: "get",
    params: param,
  });
}
export function getUid(data) {
  return request({
    url: `${BASE_API}/api/get_uid`,
    method: "post",
    data,
  });
}
export function getWordTs(param) {
  return request({
    url: `${BASE_API}/api/get_word_ts`,
    method: "get",
    params: param,
  });
}
export function getVolumeTable(param) {
  return request({
    url: `${BASE_API}/api/ecommerce`,
    method: "get",
    params: param,
  });
}

export function setMarked(data) {
  return request({
    url: `${BASE_API}/api/marked`,
    method: "post",
    data,
  });
}
export function getMarked(param) {
  return request({
    url: `${BASE_API}/api/marked`,
    method: "get",
    params: param,
  });
}
export function getSearchMarked(param) {
  return request({
    url: `${BASE_API}/api/search_marked`,
    method: "get",
    params: param,
  });
}
export function getSearchData(param) {
  return request({
    url: `${BASE_API}/api/search`,
    method: "get",
    params: param,
  });
}

export function getVolumeDataUrl(param) {
  return `${BASE_API}/api/ecommerce?` + formateObjToParamStr(param);
}
//获取top类目下载地址
export function getCategoryDataUrl(param) {
  return `${FENXI_HOST}/dwfcat2?` + formateFenxiParamStr(param);
}
//获取top品牌下载地址
export function getBrandDataUrl(param) {
  return `${FENXI_HOST}/dwtopbrands?` + formateFenxiParamStr(param);
}
//获取top商品下载地址
export function getCommodityDataUrl(param) {
  return `${FENXI_HOST}/dwtopitems?` + formateFenxiParamStr(param);
}
export function getCloudData(param) {
  return request({
    url: `${BASE_API}/api/cloud`,
    method: "get",
    params: param,
  });
}
export function getECloudData(data) {
  return request({
    url: `${BASE_API}/api/ecloud`,
    method: "post",
    data,
  });
}
export function getSocialData(param) {
  return request({
    url: `${BASE_API}/api/social`,
    method: "get",
    params: param,
  });
}
export function getPieChartData(param) {
  return request({
    url: `${BASE_API}/api/latest_social`,
    method: "get",
    params: param,
  });
}
export function getLineBarChartDataUrl(param) {
  return `${REAL_BASE_API}/api/search?` + formateObjToParamStr(param);
}
export function getPhone(param) {
  return request({
    url: `${BASE_API}/api/phone/setting`,
    method: "get",
    params: param,
  });
}
export function setPhone(data) {
  return request({
    url: `${BASE_API}/api/phone/setting`,
    method: "PUT",
    data,
  });
}
export function setPhoneNote(data) {
  return request({
    url: `${BASE_API}/api/phone/setting`,
    method: "POST",
    data,
  });
}
export function deletePhone(data) {
  return request({
    url: `${BASE_API}/api/phone/setting`,
    method: "DELETE",
    data,
  });
}
export function getMail(param) {
  return request({
    url: `${BASE_API}/api/get_mail_phone`,
    method: "get",
    params: param,
  });
}
export function addMail(data) {
  return request({
    url: `${BASE_API}/api/add_mail`,
    method: "POST",
    data,
  });
}
export function deleteMail(data) {
  return request({
    url: `${BASE_API}/api/del_mail`,
    method: "POST",
    data,
  });
}
// ****** 用户是否使用最新的类目结构 - 相关接口
export function getCatSetting(param) {
  return request({
    url: `${BASE_API}/api/cat/setting`,
    method: "get",
    params: param,
  });
}

export function putCatSetting(param) {
  return request({
    url: `${BASE_API}/api/cat/setting`,
    method: "put",
    params: param,
  });
}

export function postAskChat(param) {
  return request({
    url: `${BASE_API}/api/ask`,
    method: "post",
    data: param,
  });
}

export function postAnswer(param) {
  return request({
    url: `${BASE_API}/api/answer`,
    method: "post",
    data: param,
  });
}
export function getHistory(param) {
  return request({
    url: `${BASE_API}/api/history`,
    method: "get",
    params: param,
  });
}
export function getUserHistory(param) {
  return request({
    url: `${BASE_API}/api/user_history`,
    method: "get",
    params: param,
  });
}

export function getDefaultQuestion(param) {
  return request({
    url: `${BASE_API}/api/default_question`,
    method: "get",
    params: param,
  });
}
export function getAnswerPostsList(param) {
  return request({
    url: `${BASE_API}/api/answer_post`,
    method: "post",
    data: param,
  });
}

export function clientError(data) {
  return request({
    url: `${BASE_API}/api/client_error`,
    method: "post",
    data,
  });
}
